<template lang="pug">
	div.container-fluid
		.card.mb-3
			.card-header
				span.fa.fa-search.mr-2
				| Filtrar estadísticas
			.card-body
				.row
					.col-xs-12.col-sm-12.col-md-4.col-lg-4.col-xl-4
						.form-group(v-if="permisos.agenda_comercial_consultar_todos")
							label Agente
							input-query(inputClass="form-control", v-if="!form.usuario_ID", url="/agenda-comercial/php/api/busca-agentes.php", :realtime="true", @selected="setAgente($event)")
							.input-group(v-if="form.usuario_ID")
								input.form-control(:value="nombreUsuario", disabled="true")
								.input-group-append
									button.btn.btn-danger(@click="form.usuario_ID = null")
										span.fa.fa-trash
						.row
							.col
								.form-group
									label Desde
									.input-group
										datepicker(
											:monday-first="true"
											:bootstrap-styling="true"
											:language='$dateLang'
											v-model="form.fechaIni"
										)
										.input-group-append
												button.btn.btn-danger(@click="form.fechaIni = null")
													span.fa.fa-trash
							.col
								.form-group
									label Hasta
									.input-group
										datepicker(
											:monday-first="true"
											:bootstrap-styling="true"
											:language='$dateLang'
											v-model="form.fechaFin"
										)
										.input-group-append
											button.btn.btn-danger(@click="form.fechaFin = null")
												span.fa.fa-trash
					.col-xs-12.col-sm-12.col-md-4.col-lg-4.col-xl-4
						.form-group
							label Añade clientes
							input-query(inputClass="form-control", url="/agenda-comercial/php/api/busca-clientes.php", :realtime="true", @selected="addCliente($event)")

					.col-xs-12.col-sm-12.col-md-4.col-lg-4.col-xl-4
						table.table.table-striped.table-bordered(v-if="form.clientes.length > 0")
							tbody
								tr(v-for="cliente in form.clientes", :key="cliente.ID")
									td {{cliente.cliente}}
									td.text-right
										button.btn.btn-sm.btn-danger(@click="quitaCliente(cliente.ID)")
											span.fa.fa-trash
			.card-footer
				button.btn.btn-primary(@click="buscar")
					span.fa.fa-search.mr-2
					| Buscar
		.row.mb-3
			.col-xs-12.col-sm-12.col-md-6.col-lg-6.col-xl-3(v-if="resultados.visitasObjetivo")
				.card
					.card-header.bg-info.text-white
						| Visitas por objetivo
					.card-body
						chartjs-pie(
							:beginatzero="true"
							label="Visitas por objetivo"
							:height="200"
							:labels="resultados.visitasObjetivo.labels"
							:data="resultados.visitasObjetivo.valores"
							datalabel="Visitas por objetivo"
							:option="opcionesPie"
						)
			.col-xs-12.col-sm-12.col-md-6.col-lg-6.col-xl-3(v-if="resultados.visitasTipo")
				.card
					.card-header.bg-info.text-white
						| Visitas por tipo
					.card-body
						chartjs-pie(
							:beginatzero="true"
							label="Visitas por tipo"
							:height="200"
							:labels="resultados.visitasTipo.labels"
							:data="resultados.visitasTipo.valores"
							datalabel="Visitas por tipo"
							:option="opcionesPie"
						)
			.col-xs-12.col-sm-12.col-md-6.col-lg-6.col-xl-3(v-if="resultados.visitasCanceladas")
				.card
					.card-header.bg-info.text-white
						| Visitas realizadas v/s canceladas
					.card-body
						chartjs-pie(
							:beginatzero="true"
							label="Visitas canceladas"
							:height="200"
							:labels="resultados.visitasCanceladas.labels"
							:data="resultados.visitasCanceladas.valores"
							datalabel="Visitas canceladas"
							:option="opcionesPie"
						)
			.col-xs-12.col-sm-12.col-md-6.col-lg-6.col-xl-3(v-if="resultados.propuestasRechazadas")
				.card
					.card-header.bg-info.text-white
						| Propuestas aprobadas v/s rechazadas
					.card-body
						chartjs-pie(
							:beginatzero="true"
							label="Propuestas aprobadas"
							:height="200"
							:labels="resultados.propuestasRechazadas.labels"
							:data="resultados.propuestasRechazadas.valores"
							datalabel="Propuestas aprobadas"
							:option="opcionesPie"
						)
		.row.mb-3
			.col-xs-12.col-sm-12.col-md-4.col-lg-4.col-xl-4(v-if="resultados.visitasDiaSemana")
				.card
					.card-header.bg-danger.text-white
						| Visitas por dia de la semana
					.card-body
						chartjs-bar(
							:beginatzero="true"
							label="Visitas por dia de la semana"
							:height="200"
							:labels="resultados.visitasDiaSemana.labels"
							:data="resultados.visitasDiaSemana.valores"
							datalabel="Visitas por dia de la semana"
						)
			.col-xs-12.col-sm-12.col-md-4.col-lg-4.col-xl-4(v-if="resultados.visitasHoras")
				.card
					.card-header.bg-danger.text-white
						| Visitas por horas
					.card-body
						chartjs-bar(
							:beginatzero="true"
							label="Visitas por horas"
							:height="200"
							:labels="resultados.visitasHoras.labels"
							:data="resultados.visitasHoras.valores"
							datalabel="Visitas por horas"
						)
			.col-xs-12.col-sm-12.col-md-4.col-lg-4.col-xl-4(v-if="resultados.visitasHorasSemana")
				.card
					.card-header.bg-danger.text-white
						| Visitas por día de la semana y hora
					.card-body
						chartjs-bubble(
							:data="resultados.visitasHorasSemana"
							:options="opcionesBubble"
						)
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
	data () {
		return {
			uri: '/agenda-comercial/php/api/estadisticas/',
			diaSem: ['', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sáb', 'Dom', ''],
			form: {
				usuario_ID: null,
				clientes: [],
				fechaIni: null,
				fechaFin: null
			},
			nombreUsuario: null,
			resultados: {
				clientesMasVisitados: null,
				propuestasRechazadas: null,
				visitasDiaSemana: null,
				visitasHoras: null,
				visitasHorasSemana: null,
				visitasObjetivo: null,
				visitasTipo: null,
				visitasCanceladas: null
			},
			opcionesPie: {
				ticks: {
					min: 0
				}
			},
			opcionesBubble: {
				scales: {
					yAxes: [{
						ticks: {
							beginAtZero: true
						},
						gridLines: {
							display: true
						}
					}],
					xAxes: [{
						ticks: {
							beginAtZero: true,
							callback: (value, index, values) => {
								return this.diaSem[value]
							}
						},
						gridLines: {
							display: false
						}
					}]
				},
				legend: {
					display: false
				},
				tooltips: {
					enabled: true,
					mode: 'single',
					callbacks: {
						label: function (tooltipItems, data) {
							for (let i = 0; i < data.datasets[0].data.length; i++) {
								if (data.datasets[0].data[i].x === parseInt(tooltipItems.xLabel) && data.datasets[0].data[i].y === parseInt(tooltipItems.yLabel)) {
									return tooltipItems.yLabel + ':00 - ' + data.datasets[0].data[i].r + ' %'
								}
							}
							return tooltipItems.yLabel + ':00'
						}
					}
				},
				responsive: true,
				maintainAspectRatio: false,
				height: 200
			}
		}
	},
	computed: {
		...mapGetters({
			'permisos': 'permisos/permisos'
		})
	},

	methods: {
		setAgente (ev) {
			this.form.usuario_ID = ev.datos.ID
			this.nombreUsuario = ev.datos.nombre + ' ' + ev.datos.apellidos
			this.buscar()
		},

		addCliente (ev) {
			for (let i = 0; i < this.form.clientes.length; i++) {
				if (this.form.clientes[i].ID === ev.datos.ID) {
					return
				}
			}

			this.form.clientes.push(ev.datos)
		},

		quitaCliente (ID) {
			for (let i = this.form.clientes.length - 1; i >= 0; i--) {
				if (this.form.clientes[i].ID === ID) {
					this.form.clientes.splice(i, 1)
				}
			}
		},

		buscar () {
			if (this.form.fechaIni) {
				this.form.fechaIni.setHours(0)
				this.form.fechaIni.setMinutes(0)
				this.form.fechaIni.setSeconds(0)
				this.form.fechaIni.setMilliseconds(0)
			}

			if (this.form.fechaFin) {
				this.form.fechaFin.setHours(23)
				this.form.fechaFin.setMinutes(59)
				this.form.fechaFin.setSeconds(59)
				this.form.fechaFin.setMilliseconds(999)
			}
			const form = {
				usuario_ID: this.form.usuario_ID,
				clientes: this.form.clientes,
				fechaIni: (this.form.fechaIni) ? Math.floor(this.form.fechaIni.getTime() / 1000) : null,
				fechaFin: (this.form.fechaFin) ? Math.floor(this.form.fechaFin.getTime() / 1000) : null
			}

			this.resultados = {
				clientesMasVisitados: null,
				propuestasRechazadas: null,
				visitasDiaSemana: null,
				visitasHoras: null,
				visitasHorasSemana: null,
				visitasObjetivo: null,
				visitasTipo: null,
				visitasCanceladas: null
			}
			axios.post(this.uri + 'index.php', form)
				.then(res => {
					this.resultados = res.data.resultados
				})
				.catch(this.$responseError)
			// axios.post(this.uri + 'visitas-por-objetivo.php', form)
			// 	.then(res => {
			// 		this.resultados.visitasObjetivo = res.data
			// 	})
			// 	.catch(e => {
			// 		console.error(e)
			// 	})

			// axios.post(this.uri + 'visitas-por-tipo.php', form)
			// 	.then(res => {
			// 		this.resultados.visitasTipo = res.data
			// 	})
			// 	.catch(e => {
			// 		console.error(e)
			// 	})

			// axios.post(this.uri + 'visitas-rechazadas.php', form)
			// 	.then(res => {
			// 		this.resultados.visitasCanceladas = res.data
			// 	})
			// 	.catch(e => {
			// 		console.error(e)
			// 	})
			// axios.post(this.uri + 'propuestas-rechazadas.php', form)
			// 	.then(res => {
			// 		this.resultados.propuestasRechazadas = res.data
			// 	})
			// 	.catch(e => {
			// 		console.error(e)
			// 	})

			// axios.post(this.uri + 'visitas-por-diasemana.php', form)
			// 	.then(res => {
			// 		this.resultados.visitasDiaSemana = res.data
			// 	})
			// 	.catch(e => {
			// 		console.error(e)
			// 	})
			// axios.post(this.uri + 'visitas-por-horas.php', form)
			// 	.then(res => {
			// 		this.resultados.visitasHoras = res.data
			// 	})
			// 	.catch(e => {
			// 		console.error(e)
			// 	})
			// axios.post(this.uri + 'visitas-por-horas-semana.php', form)
			// 	.then(res => {
			// 		this.resultados.visitasHorasSemana = {
			// 			labels: ['Visitas por días y horas'],
			// 			datasets: [
			// 				{
			// 					backgroundColor: '#f87979',
			// 					pointBackgroundColor: 'white',
			// 					borderWidth: 1,
			// 					pointBorderColor: '#249EBF',
			// 					labels: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'],
			// 					data: res.data.datos
			// 				}
			// 			]
			// 		}
			// 	})
			// 	.catch(e => {
			// 		console.error(e)
			// 	})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/agenda-comercial/vue/componentes/estadisticas/estadisticas.vue